// Remove import { EVENTS } from "@archetype-themes/utils/events";
// Assume EVENTS is available globally

let hasLoadedBefore = false;

class CollectionHeader extends HTMLElement {
  constructor() {
    super();

    this.overlayHeader = false;
    this.heroImageContainer = this.querySelector(".collection-hero");
    this.handleOverlayHeaderChange = this.handleOverlayHeaderChange.bind(this);
  }

  connectedCallback() {
    this.abortController = new AbortController();

    document.addEventListener(
      EVENTS.overlayHeaderChange,
      this.handleOverlayHeaderChange,
      {
        signal: this.abortController.signal,
      }
    );

    if (this.heroImageContainer) {
      if (hasLoadedBefore) {
        this.checkIfNeedReload();
      }

      this.heroImageContainer.classList.remove("loading", "loading--delayed");
      this.heroImageContainer.classList.add("loaded");
    } else if (this.overlayHeader) {
      this.dispatchEvent(new CustomEvent(EVENTS.headerOverlayDisable), {
        bubbles: true,
      });
    }

    hasLoadedBefore = true;
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  handleOverlayHeaderChange(event) {
    this.overlayHeader = event.detail.overlayHeader;

    if (!this.overlayHeader && !this.heroImageContainer) {
      this.dispatchEvent(new CustomEvent(EVENTS.headerOverlayDisable), {
        bubbles: true,
      });
    }
  }

  checkIfNeedReload() {
    if (!Shopify.designMode) {
      return;
    }

    if (this.overlayHeader) {
      const header = document.querySelector(".header-wrapper");
      if (!header.classList.contains("header-wrapper--overlay")) {
        location.reload();
      }
    }
  }
}

if (!window.customElements.get("section-collection-header")) {
  window.customElements.define("section-collection-header", CollectionHeader);
}

document.addEventListener("DOMContentLoaded", function () {
  var container = document.querySelector(
    ".collection-sub-navigation__container"
  );
  var skeleton = document.querySelector(".collection-sub-navigation-skeleton");
  var navigation = document.querySelector(".collection-sub-navigation");

  if (container && typeof Flickity !== "undefined") {
    console.log(
      "[CollectionNav] Flickity initializing on sub-navigation container",
      container
    );
    var flkty = new Flickity(container, {
      cellAlign: "left",
      contain: false,
      freeScroll: true,
      prevNextButtons: false,
      pageDots: false,
      draggable: true,
      dragThreshold: 3,
      friction: 0.28,
      selectedAttraction: 0.025,
      percentPosition: false,
    });

    // Function to hide skeleton and show navigation
    function showNavigation() {
      console.log("[CollectionNav] showNavigation called", {
        skeleton,
        navigation,
      });
      if (skeleton) {
        skeleton.style.display = "none";
      }
      if (navigation) {
        navigation.style.display = "block";
        // Add a small delay to ensure smooth transition
        setTimeout(function () {
          navigation.style.opacity = "1";
          console.log("[CollectionNav] Navigation opacity set to 1");
        }, 10);
      }
    }

    // Try multiple approaches to ensure the transition happens
    flkty.on("ready", function () {
      console.log("[CollectionNav] Flickity ready event fired");
      showNavigation();
    });

    // Fallback: use a timeout to ensure transition happens
    setTimeout(function () {
      console.log("[CollectionNav] 1000ms fallback", {
        skeletonDisplay: skeleton && skeleton.style.display,
      });
      if (skeleton && skeleton.style.display !== "none") {
        showNavigation();
      }
    }, 1000);

    // Additional fallback: check if Flickity is initialized
    setTimeout(function () {
      console.log("[CollectionNav] 500ms Flickity slides fallback", {
        flkty,
        skeletonDisplay: skeleton && skeleton.style.display,
      });
      if (
        flkty &&
        flkty.slides &&
        skeleton &&
        skeleton.style.display !== "none"
      ) {
        showNavigation();
      }
    }, 500);

    // Firefox-specific fallback: force show after 2s if still not visible
    setTimeout(function () {
      console.log("[CollectionNav] 2000ms Firefox fallback", {
        skeletonDisplay: skeleton && skeleton.style.display,
      });
      if (skeleton && skeleton.style.display !== "none") {
        showNavigation();
        console.warn(
          "[CollectionNav] Forced navigation visible due to Firefox fallback."
        );
      }
    }, 2000);
  }
});
